import { BlogSection } from '@/types/blog';

export const prozessor: BlogSection = {
  id: 'prozessor',
  title: 'Der Prozessor: Wie das System denkt',
  content: `
    <p class="mb-4">
      Regeln sind die Software, aber was ist die CPU? Mein Denkprozess folgt oft einem Muster: Eine leidenschaftliche Idee (der "Jamie Oliver"), gefolgt von einer kritischen Dekonstruktion der Risiken (der "Sebastian Lege"), mündet in einer Synthese, die auf Prinzipien beruht (die "Mai Think"). Dieser Dreiklang ist der Kern des Prozessors.
    </p>
  `
};
